
import { Component, Vue } from "vue-property-decorator"
@Component
export default class QuizPageWeb extends Vue {
  multipleChoiceView = true
  resSum = 0
  buttonClicked = false
  backQuote = ''
  count=0
  qstns = []
  currentObj: any = null
  backQuotesArr = [
    `Let's push each other in case any one of us is confronted with life issues.`,
    `How about a long walk by the woods holding each others hand.`,
    `Maybe we can't have kids, why not be each others for the rest of our lives!`,
    `I was there for her to hold on to and give a shoulder to cry...`,
    `Maybe a relationship between a husband and a wife is all  about being there for each other when they really need  you.`,
    `She cuddles her arms around mine and loved listening to me, she never loosens up her hands just like an inseparable emotion.`,
    `My subconscious told me that she was the one that I have been searching for all my life the moment I looked into her mesmerizing eyes.`,
    `Kids do look cute and adorable when they are mad at you.`,
    `There is nothing more pathetic in life than having to grieve alone`,
    `Guarantee can be a stupid word for life!!`
  ]


  get isMobileView() {
    return this.$store.state.isMobileView
  }

  mounted() {
    this.qstns = this.$store.state.wholeObjs
    this.currentObj = this.qstns[this.count]
  }
  
  optionClicked(index: number) {
    this.resSum += this.currentObj.weight[index]
    this.count +=1
    if (this.count == 10) {
      let which = 0
      if (this.resSum >= 100 && this.resSum <= 120) {
          which = 0
      } else if (this.resSum >= 130 && this.resSum <= 170) {
            which = 1
      } else if (this.resSum >= 180 && this.resSum <= 220) {
            which = 2
      } else if (this.resSum >= 230 && this.resSum <= 260) {
            which = 3
      } else if (this.resSum >= 270 && this.resSum <= 300) {
           which = 4
      }
      this.$router.push({path: `/result/${which}/me`})
    }
    this.currentObj = this.qstns[this.count]
    if (this.count == 5) {
      this.multipleChoiceView = false
    }


  }
 

}
